import React, { Component } from 'react'
import { autobind } from 'react-decoration'
import cn from 'classnames'
import onClickOutside from 'react-onclickoutside'

export const Button = ({ text, primary, color, noBorder, ...rest }) => {
  const colorStyle = primary ? { backgroundColor: color } : { color }
  const borderStyle = noBorder ? { border: 'none' } : {}
  const style = { ...colorStyle, ...borderStyle }
  return (
    <div className={cn('button', { primary })} style={style} {...rest}>
      {text}
      <style jsx>{`
        .button {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          box-sizing: border-box;
          cursor: pointer;
        }
        .button.primary {
          color: #ffffff;
          background-color: #4a90e2;
        }
        .button:not(.primary) {
          color: #4a90e2;
          border: 1px solid #4a90e2;
          background-color: #ffffff;
        }
      `}</style>
    </div>
  )
}

@onClickOutside
export class Field extends Component {
  state = { isFocused: false, value: '' }

  @autobind
  handleChange(e) {
    const { onChange } = this.props
    const newValue = e.target.value
    this.setState(() => ({
      value: newValue,
    }))
    onChange && onChange(newValue)
  }

  @autobind
  handleFocus() {
    this.setState(() => ({ isFocused: true }))
  }

  @autobind
  handleEnterPress(e) {
    if (e.which === 13 || e.keyCode === 13) {
      this.handleAddBtnClick()
    }
  }

  @autobind
  handleClickOutside() {
    this.setState(() => ({ isFocused: false }))
  }

  @autobind
  handleAddBtnClick() {
    const { onAddBtnClick } = this.props
    onAddBtnClick && onAddBtnClick(this.state.value)
    setImmediate(this.handleClickOutside)
    this.setState(() => ({
      value: '',
    }))
  }

  render() {
    const { onChange, onAddBtnClick, ...rest } = this.props
    const { isFocused, value } = this.state
    return (
      <div>
        <div
          className={cn('field', { focused: isFocused })}
          onClick={this.handleFocus}
        >
          <input
            type="text"
            value={value}
            onChange={this.handleChange}
            onKeyPress={this.handleEnterPress}
            className={cn({ focused: isFocused })}
            {...rest}
          />
          {isFocused &&
            value &&
            <div className="button" onClick={this.handleAddBtnClick}>
              Add
            </div>}
        </div>
        {isFocused &&
          <div className="shadow" onClick={this.handleClickOutside} />}
        <style jsx>{`
          .field {
            z-index: 2;
            padding: 10px 17px;
            background-color: #f4f4f7;
            border-radius: 4px;
            width: 100%;
            height: 40px;
            box-sizing: border-box;
            position: relative;
          }
          .field.focused {
            right: calc(400px - 100%);
            width: 400px;
            background-color: #ffffff;
          }
          input {
            outline: none;
            border: none;
            background-color: #f4f4f7;
            font-size: 14px;
            width: 100%;
          }
          input.focused {
            background-color: #ffffff;
            width: calc(100% - 70px);
          }
          .button {
            cursor: pointer;
            position: absolute;
            border-radius: 4px;
            background-color: #4a90e2;
            width: 64px;
            height: 40px;
            box-sizing: border-box;
            right: 0;
            top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
          }
          .shadow {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            background-color: rgba(0, 0, 0, 0.5);
          }
        `}</style>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/input/index.js